/* SALT N SOUL — Variantenbild beim Swatch-Wechsel aktualisieren */
(function () {
  'use strict';
  const base = (u) => (u || '').split('?')[0].split('/').pop();
  document.querySelectorAll('[data-product-page]').forEach(async (page) => {
    const form = page.querySelector('[data-product-form]');
    const idInput = form && form.querySelector('[data-variant-id]');
    const hero = page.querySelector('.product-page__hero img');
    if (!idInput || !hero) return;
    const handle = (location.pathname.split('/products/')[1] || '').split('/')[0];
    if (!handle) return;
    let product;
    try { product = await fetch('/products/' + handle + '.js').then((r) => r.json()); } catch (e) { return; }
    const update = () => {
      const v = product.variants.find((v) => String(v.id) === String(idInput.value));
      const img = v && v.featured_image && v.featured_image.src;
      if (!img) return;
      const thumb = Array.from(page.querySelectorAll('[data-thumb]')).find((t) => base(t.dataset.full) === base(img));
      hero.removeAttribute('srcset');
      hero.src = thumb ? thumb.dataset.full : img;
      page.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
    };
    form.querySelectorAll('[data-option-input]').forEach((i) => i.addEventListener('change', () => setTimeout(update, 0)));
  });
})();
